<template>
  <div>
    <!-- Sidebar -->
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner v-slimscroll">
        <div class="sidebar-menu">
          <ul>
            <li>
              <Skeleton :count="10" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- /Sidebar -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton
  },

  computed: {
    ...mapGetters([
      "roomListArr",
      "agentSession",
      "activeRoomId",
      "NEW_NUM_UNREAD_MESSAGE_ROOM_Data"
    ]),

    currentpage() {
      return this.$route.path;
    }
  },
  data() {
    return {};
    //  isactive : true
  },
  async created() {},
  methods: {
    async changeRoomListArr(data) {
      console.log("changeHotChatListArr::", data);
      var newArr = this.getUniqueListBy(data, "id");
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      this.$store.dispatch("omniroom/setRoomListArr", newArr);
    }
  }
};
</script>
           <style>
.hide {
  visibility: hidden !important;
}
.sidebar {
  height: 100vh;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.sidebar::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.sidebar::-webkit-scrollbar-thumb {
  /* background: red;  */
  border-radius: 10px;
  /* background: rgb(204, 204, 204); */
  background-color: transparent;
}

/* Handle on hover */
.sidebar::-webkit-scrollbar-thumb:hover {
  /* background: #b30000;  */
  background: rgb(204, 204, 204);
}
.sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}
</style> 


// WEBPACK FOOTER //
// src/views/agentconnect/LeftSidebar.vue